export const ICON_WIDTH = 'iconwidth';
export const ICON_HEIGHT = 'iconheight';
export const N_TYPO = 'ntypeo';
export const G_MARGIN = 'gmargin';
export const C_BORDER = 'cborder';
export const C_BRADIUS = 'cbradius';
export const G_TYPO = 'gtypo';

